import { useState } from 'react';

export const useLatestVersion = () => {
  const [checkedLatestVersion, setCheckedLatestVersion] = useState<boolean>(() => {
    const savedChecked = localStorage.getItem('doc_latest_version');
    if (savedChecked === null) {
      localStorage.setItem('doc_latest_version', 'true');
    }
    return savedChecked === 'true';
  });
  return {
    checkedLatestVersion,
    setCheckedLatestVersion,
  };
};
